// <ah-delivery-estimate>; date maths tested in tooling
const iso=d=>d.toISOString().slice(0,10),DF=o=>new Intl.DateTimeFormat('en-GB',o),n='numeric';
export const fmt=s=>DF({weekday:'short',day:n,month:'short',timeZone:'UTC'}).format(new Date(s));
export const dur=(m,f='{h}h {m}m')=>(m>59?f:f.slice(f.indexOf('{m}'))).replace('{h}',m/60|0).replace('{m}',m%60);
export function estimate(now,{cutoff=14,express=1,min=2,max=3,holidays=[]}={}){
const p={};
for(const x of DF({timeZone:'Europe/London',year:n,month:n,day:n,hour:n,minute:n,hourCycle:'h23'}).formatToParts(now))p[x.type]=+x.value;
const work=d=>d.getUTCDay()%6&&!holidays.includes(iso(d)),
next=d=>{d=new Date(d);do d.setUTCDate(d.getUTCDate()+1);while(!work(d));return d},
add=(d,k)=>{while(k-->0)d=next(d);return d},
left=cutoff*60-p.hour*60-p.minute;
let d=new Date(Date.UTC(p.year,p.month-1,p.day));
const before=!!work(d)&&left>0;
if(!before)d=next(d);
return{before,mins:before?left:0,express:iso(add(d,express)),from:iso(add(d,min)),to:iso(add(d,max))};
}
const C=globalThis.customElements;
C&&!C.get('ah-delivery-estimate')&&C.define('ah-delivery-estimate',class extends HTMLElement{
connectedCallback(){this.v=()=>this.tick();document.addEventListener('visibilitychange',this.v);this.tick()}
disconnectedCallback(){clearTimeout(this.t);document.removeEventListener('visibilitychange',this.v)}
tick(){
clearTimeout(this.t);
const s=this.dataset,e=estimate(new Date(),{cutoff:+s.cutoff,express:+s.express,min:+s.min,max:+s.max,holidays:(s.holidays||'').split(/\s+/)});
e.time=dur(e.mins,s.dur);
for(const[k,t]of[['x',e.before?'before':'after'],['s','standard']]){
const tpl=this.querySelector(`template[data-t=${t}]`),out=this.querySelector(`[data-slot=${k}]`);
if(!tpl||!out)return;
const c=tpl.content.cloneNode(true);
for(const el of c.querySelectorAll('[data-k]')){const v=e[el.dataset.k];el.textContent=el.localName=='time'?fmt(el.dateTime=v):v}
out.replaceChildren(c);
}
s.state='live';
if(!document.hidden)this.t=setTimeout(this.v,60500-Date.now()%60000);
}
});
